

const { ccclass, property } = cc._decorator;

export enum CardNameIndex{
    card_unknow = 0,
    card_A = 1,
    card_2 = 2,
    card_3 = 3,
    card_4 = 4,
    card_5 = 5,
    card_6 = 6,
    card_7 = 7,
    card_8 = 8,
    card_9 = 9,
    card_10 = 10,
    card_J = 11,
    card_Q = 12,
    card_K = 13,
    card_small_king = 14,
    card_big_king = 15,
    end,
}

export enum CardColor{
    color_unknow = 0,
    color_black_heart = 1,
    color_red_heart = 2,
    color_plum = 3,
    color_square = 4,
}

export class Card{
    static cardValueMap: number[] = [0, 12, 14, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 16, 18]
    static cardLogicPointMap: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 10, 10, 10]
    static cardLogicIndexMap: number[] = [0, 14, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
    static max_card_value: number = 15
    code: number = 0
    index: CardNameIndex = CardNameIndex.card_unknow
    logicIndex: number = 0
    color: CardColor = CardColor.color_unknow
    logicCode: number = 0
    fullCode: number = 0
    srcId: number = 0
    static makeCardByCode(code: number): Card{
        let card = new Card()  
        card.fullCode = code
        code = Card.fullCodeToCode(code)
        card.code = code
        card.srcId = Card.codeToSrcId(code)
        card.logicCode = Card.codeToLogicCode(code)
        card.index = Card.codeToIndex(code)
        card.logicIndex = Card.cardLogicIndexMap[card.index]
        card.color = card.logicCode - (card.index - 1) * 4
        return card
    }

    static makeCardByColorAnIndex(color: CardColor, index: number): Card{
        let card = new Card()
        card.color = color
        card.index = index
        card.code = Card.colorIndexToCode(color, index)
        return card
    }

    static codeToFullCode(code: number, areaIndex: number){
        return code + 1280 * areaIndex
    }

    static fullCodeToCode(fullCode: number){
        return fullCode % 1280
    }

    static fullCodeToAreaIndex(fullCode: number){
        return Math.floor(fullCode / 1280)
    }

    static fullCodeToLogicCode(fullCode: number){
        return Card.codeToLogicCode(Card.fullCodeToCode(fullCode))
    }

    static codeToSrcId(code: number){
        code = Card.fullCodeToCode(code)
        return Math.floor(code / 256)
    }

    static codeToLogicCode(code: number){
        code = Card.fullCodeToCode(code)
        return code % 256
    }

    static colorIndexToCode(color: CardColor, index: number): number{
        return (index - 1) * 4 + color
    }

    static codeToIndex(code: number): number{
        code = Card.fullCodeToCode(code)
        code = Card.codeToLogicCode(code)
        return Math.floor((code - 1) / 4 + 1)
    }    

    static codeToColor(code: number): number{
        code = Card.fullCodeToCode(code)
        code = Card.codeToLogicCode(code)
        let index = Card.codeToIndex(code)
        return code - (index - 1) * 4
    }

    static codeToValue(code: number): number{
        code = Card.fullCodeToCode(code)
        code = Card.codeToLogicCode(code)
        let index = Card.codeToIndex(code)
        return Card.indexToValue(index)
    }

    static valueToIndex(value: number): number{
        for (let i = 0; i < Card.cardValueMap.length; i++) {
            const element = Card.cardValueMap[i];
            if(element == value){
                return i
            }
        }
    }

    static indexToValue(index: number): number{
        return Card.cardValueMap[index]
    }

    static indexToLogicPoint(index: number): number{
        return Card.cardLogicPointMap[index]
    }

    static codeToLogicPoint(code: number): number{
        code = Card.fullCodeToCode(code)
        code = Card.codeToLogicCode(code)
        let index = Card.codeToIndex(code)
        return Card.indexToLogicPoint(index)
    }

    static isQ2(code: number): boolean{
        let card = Card.makeCardByCode(code)
        return (card.index == CardNameIndex.card_2 && card.color == CardColor.color_plum) || (card.index == CardNameIndex.card_Q && card.color == CardColor.color_black_heart) 
    }
}


